var _defs, _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBusinesstime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.79 15.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1e3f76;opacity:0.5;}.cls-2{fill:#161c32;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 7.89,
    cy: 7.89,
    r: 7.89
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.1,12.07a1.95,1.95,0,1,0,2,1.95A1.95,1.95,0,0,0,15.1,12.07Zm.65,2.16H15a.13.13,0,0,1-.14-.13v-.95a.22.22,0,1,1,.44,0v.65h.43A.22.22,0,0,1,16,14,.21.21,0,0,1,15.75,14.23Zm-3-.43H11.2a.22.22,0,0,1-.22-.22v-.65H8.38v2a.67.67,0,0,0,.65.65h4.23A2.36,2.36,0,0,1,12.72,14Zm2.38-2.17h.22V11a.68.68,0,0,0-.65-.65H13.58V9.68A.67.67,0,0,0,12.93,9H10.77a.67.67,0,0,0-.65.65v.65H9a.68.68,0,0,0-.65.65V12.5h4.88A2.39,2.39,0,0,1,15.1,11.63Zm-2.17-1.3H10.77V9.68h2.16Z",
    transform: "translate(-4.64 -4.61)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinesstime);
export default __webpack_public_path__ + "static/media/businesstime.c5d70c4f79ff42a23a5ac2933f111d78.svg";
export { ForwardRef as ReactComponent };